import styled from '@emotion/styled';
import { Avatar, ButtonGroup, Grow, MenuItem, Popper, Button } from '@mui/material';

const StyledButton = styled(Button)`
  height: 45px;
  width: max-content;
  border-radius: 100px;
  color: #372240;
  text-align: center;
  font-family: var(--font-work-sans), sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 136.8%; /* 24.624px */
  text-transform: none;
  background: ${props => (props.className === 'active' ? '#FFFFFF' : '#fff3dc50')};
  color: #000000;
  :hover {
    cursor: pointer;
    background: #ffffff;
  }
  @media (max-width: 768px) {
    width: max-content;
    padding-right: 5px;
  }
`;

export default StyledButton;

export const StyledMenuItem = styled(MenuItem)`
  width: auto;
  font-family: var(--font-work-sans), sans-serif;
  font-size: 16px;
  background: ${props => (props.className === 'active' ? '#fff3dc50' : '#FFFFFF')};
  z-index: 9999;
  :hover {
    color: #231727;
    cursor: pointer;
    background: #ffcf31;
  }
  .Mui-selected {
    background: #ffffff;
  }
  padding: 10px 30px 10px 10px;
  justify-content: flex-start;
`;

export const StyledButtonGroup = styled(ButtonGroup)`
  color: '#fff3dc50';
  border-radius: 100px;
  margin-right: 10px;
  background: ${props => (props.className === 'selected' ? '#FFFFFF' : '#fff3dc50')};
  @media (max-width: 768px) {
    width: max-content;
  }
`;

export const StyledAvatar = styled(Avatar)`
  border-radius: 0;
  & > img {
    object-fit: contain;
  }
`;

export const StyledGrow = styled(Grow)`
  width: 250;
  overflow: 'hidden';
  background-color: '#ffffff';
  border-radius: 15px;
  z-index: 9998;
  height: auto;
`;

export const StyledPopper = styled(Popper)`
  z-index: 9999;
  @media (max-width: 768px) {
    width: auto;
  }
`;
